import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';

import { CustomizeColumnsInsightChangeEvent } from './customize-columns.insight.model';
import {
    NestedNode,
    NestedNodeSelectInsightChangeEvent,
} from './nested-node-select.insight.model';
import { OptionalColumn } from './optional-column.insight.model';

@Component({
    selector: 'customize-columns-insight',
    templateUrl: './customize-columns.insight.component.html',
})
export class CustomizeColumnsInsightComponent
    implements OnChanges, OnInit, OnDestroy
{
    @Input() columns: OptionalColumn[];
    @Input() selection: OptionalColumn[];
    @Output() change: EventEmitter<CustomizeColumnsInsightChangeEvent>;

    localState: {
        nodes: NestedNode[];
        selection: NestedNode[];
    };

    constructor() {
        this.change = new EventEmitter();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.columns != null || changes.selection != null) {
            this._setValues();
        }
    }

    ngOnInit(): void {
        this._setValues();
    }

    ngOnDestroy(): void {
        this.change.complete();
    }

    _onChange(event: NestedNodeSelectInsightChangeEvent): void {
        const mapToColumn = (node: NestedNode): OptionalColumn =>
            this.columns.find((e) => e.id.toString() === node.id);
        this.change?.emit({
            selected: event.selected.map(mapToColumn),
        });
    }

    private _setValues(): void {
        const mapToNode = (oc: OptionalColumn): NestedNode => {
            return {
                id: oc.id.toString(),
                label: oc.name,
                checked: oc.forced,
                disabled: oc.disabled,
                hidden: oc.hidden,
            };
        };
        const nodes = this.columns.map(mapToNode);
        const selection = this.selection.map(mapToNode);
        this.localState = { nodes, selection };
    }
}
